import type { MutableRefObject } from 'react'
import { useFilterableCarsAvailable } from '@/scopes/checkout/filterableCars/domain/hooks'
import { useDebouncedCallback } from '@/scopes/common/components/hooks/useDebouncedCallback'
import { Pagination } from '@sunwebgroup/ui-components/uds'
import * as React from 'react'

export function CarsPagination({ scrollToElement }: { scrollToElement: MutableRefObject<HTMLDivElement | null> }) {
  const { goToNextPage, goToPreviousPage, goToPage, currentPage, totalPages } = useFilterableCarsAvailable()

  const scrollToTop = useDebouncedCallback(() => {
    requestAnimationFrame(() => {
      if (scrollToElement.current) {
        scrollToElement.current.scrollIntoView({ behavior: 'smooth', block: 'start' })
      }
    })
  }, 100)

  const handlePreviousPage = () => {
    goToPreviousPage()
    scrollToTop()
  }
  const handleNextPage = () => {
    goToNextPage()
    scrollToTop()
  }
  const handleGoToPage = (pageNumber: number) => {
    goToPage(pageNumber)
    scrollToTop()
  }

  return (
    <Pagination
      currentPage={currentPage}
      totalPages={totalPages}
      goToPreviousPage={handlePreviousPage}
      goToNextPage={handleNextPage}
      goToPage={handleGoToPage}
    />
  )
}
